import angular from 'angular'

import { has, isArray } from 'lodash-es'

//  SIGN  DIFF   DEF HEIGHT   DEVICE
//               x ROWS NUM
//
//  XS                       IPhone
//  S     d=350    250x2     IPad
//  M     d=400    270x3     IPad Pro
//  L     d=500    290x4     Laptop
//  XL    d=500    330x5     Desktop
//  XXL            350x6     2K Display

const DEF_HOR_SIGNS = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
const DEF_HOR_PLANS = [
  { XS: 2, S: 3, M: 4, L: 5, XL: 6, XXL: 7 },
  { XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6 },
  { XS: 1, S: 1, M: 2, L: 3, XL: 4, XXL: 5 }
]
const DEF_HOR_MQ = { XS: 0, S: 550, M: 900, L: 1300, XL: 1800, XXL: 2300 }

//  SIGN  DIFF   DEF HEIGHT   TYPE                   EXAMPLE DEVICES
//               x ROWS NUM             (LM is Landscape Mode, PM is Portrait Mode)
//                                              //
//  XS                       Mobile    IPhone LM (320-414)
//  S     d=240    180x2     Mobile    IPhone 5 (454-548), IPhone 6 (551-647),
//  M     d=240    190x3     Mobile    IPad LM (654-748), IphoneX (702-796), Laptop (810-900)
//  L     d=350    270x3     Desktop   IPad (910-1004), IPadPro LM (910-1004), Desktop (990-1080)
//  XL    d=350    280x4     Desktop   IPadPro (1252-1345), 2K Display (1350-1440), Laptop PM (1510-1600)
//  XXL            290x5     Desktop   Desktop PM (1830-1920), 2K Display PM (2450-2560)

const DEF_VER_SIGNS = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
const DEF_VER_PLANS = [
  { XS: 2, S: 3, M: 4, L: 4, XL: 5, XXL: 6 },
  { XS: 1, S: 2, M: 3, L: 3, XL: 4, XXL: 5 },
  { XS: 1, S: 1, M: 2, L: 2, XL: 3, XXL: 4 }
]
const DEF_VER_MQ = { XS: 0, S: 420, M: 660, L: 900, XL: 1250, XXL: 1600 }

angular
  .module('ggs.gallery-preview-flow')
  .factory('calcSizeProps', CalcSizerPropProvider)

function CalcSizerPropProvider() {

  return calcSizeProps

  function calcSizeProps(gridSide, properties) {
    const modeMasonry = !properties.carousel_mode
    const modeCarouselClassic = properties.carousel_layout_classic
    const modeCarouselStaticRows = properties.carousel_layout_static_rows
    const modeCarouselFillViewport = properties.carousel_layout_fill_viewport

    let userPlan = null
    let userPlanUse = null
    if (modeMasonry) {
      userPlan = properties.custom_preview_width
      userPlanUse = properties.custom_preview_width_use
    } else if (modeCarouselClassic) {
      userPlan = properties.custom_preview_grid
      userPlanUse = properties.custom_preview_grid_use
    } else if (modeCarouselStaticRows) {
      userPlan = properties.adaptive_static_rows
      userPlanUse = properties.adaptive_static_rows_use
    } else if (modeCarouselFillViewport) {
      userPlan = properties.custom_preview_height
      userPlanUse = properties.custom_preview_height_use
    }

    let actualSigns = null
    let actualPlan = null
    let actualMQ = null
    if (modeMasonry || modeCarouselClassic) {
      actualSigns = DEF_HOR_SIGNS
      actualPlan = userPlanUse ? userPlan : DEF_HOR_PLANS[properties.post_width_option]
      actualMQ = DEF_HOR_MQ
    } else {
      actualSigns = DEF_VER_SIGNS
      actualPlan = userPlanUse ? userPlan : DEF_VER_PLANS[properties.post_width_option]
      actualMQ = DEF_VER_MQ
    }

    let modernPlan = null
    if (isArray(actualPlan)) {
      modernPlan = actualPlan
    } else if (modeMasonry) {
      modernPlan = []
      for (const sign of actualSigns) {
        modernPlan.push({
          from: actualMQ[sign],
          cols: actualPlan[sign]
        })
      }
    } else if (modeCarouselClassic) {
      modernPlan = []
      for (const sign of actualSigns) {
        modernPlan.push({
          from: actualMQ[sign],
          cols: actualPlan[sign],
          rows: properties.carousel_classic_rows
        })
      }
    } else if (modeCarouselStaticRows) {
      modernPlan = []
      modernPlan.push({
        from: 0,
        rows: properties.carousel_static_rows,
        rowHeight: properties.carousel_static_row_height
      })
    } else if (modeCarouselFillViewport) {
      modernPlan = []
      for (const sign of actualSigns) {
        modernPlan.push({
          from: actualMQ[sign],
          rows: actualPlan[sign]
        })
      }
    }

    if (properties.highlight_all_posts) {
      for (const option of modernPlan) {
        if (has(option, 'rowHeight')) option.rowHeight = Math.ceil(option.rowHeight * 2)
        if (has(option, 'rows')) option.rows = Math.max(Math.ceil(option.rows / 2), 1)
        if (has(option, 'cols')) option.cols = Math.max(Math.ceil(option.cols / 2), 1)
      }
    }

    let modernOption = null
    for (const option of modernPlan) {
      if (option.from < gridSide) {
        modernOption = option
      } else {
        break
      }
    }
    if (!modernOption) {
      modernOption = modernPlan[0]
    }

    return modernOption
  }
}
